/**
 * FERP Portal - Template List Page (DRR-074: Tabulator DRY Template)
 *
 * DESIGN Phase: Reusable configuration templates for workflows and primitives.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function TemplateListPage() {
  return <TabulatorPrimitiveManager primitiveType="template" />;
}

export default TemplateListPage;
